import { AccountFileUploadRequest } from '../structures/request/AccountFileUploadRequest';
import { FileManaged } from '../structures/response/FileManaged';
import apiClient from './apiClient';

export const fileUpload = async (
  params: AccountFileUploadRequest
): Promise<FileManaged> => {
  const url = 'account/file/upload';
  const fd = new FormData();
  fd.append('file', params.file);
  fd.append('category', params.category);
  return apiClient.post(url, fd).then((r) => r.data);
};

export const fileDelete = (id: number | string): Promise<void> =>
  apiClient.delete(`file/storage/delete?id=${id}`).then((r) => r.data);

export const fileView = async (
  id: number | string,
  content?: boolean
): Promise<FileManaged> => {
  const params = new URLSearchParams({ id: id.toString() });
  if (content) {
    params.append('expand', 'content');
  }
  return apiClient
    .get(`file/storage/view?${params.toString()}`)
    .then((r) => r.data)
    .catch((e) => {
      throw e.response.data;
    });
};
